<canvas #canvas role="img" attr.aria-label="{{ title }}"></canvas>
